define([
    "./macroModule",
    "./macroRouter",
    "./macroControllerEdition",
    "./macroControllerSearch",
    "./macroService"
], function () {
});